// @flow

import type { Player$SourceStatus } from '../types/Source';

export const APPROVED_TIMEDATA_STATUS: Player$SourceStatus = 2;
export const UNAPPROVED_TIMEDATA_STATUS: Player$SourceStatus = 1;
export const TRANSLATABLE_TIMEDATA_STATUS: Player$SourceStatus = 0;
export const UNTRANSLATED_TIMEDATA_STATUS: Player$SourceStatus = 3;
